import React from 'react'

import { InputProps, Input } from '../atoms/Input'

export function InputPassword({
  name,
  value,
  readOnly,
  onChange,
  ...rest
}: InputProps) {
  return (
    <Input
      type="password"
      name={name}
      value={value}
      readOnly={readOnly}
      onChange={onChange}
      {...rest}
    />
  )
}
